import { TemplateResult } from 'lit';

export declare interface ModalBody {
  template: TemplateResult;
}

export declare interface ModalButton {
  label: string;
  ariaLabel?: string;
  className?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  showSpinner?: boolean;
  spinnerMessage?: string;
}

export declare interface ModalConfig {
  body: ModalBody;
  header: string;
  headerClassName?: string;
  isHeaderTextBold?: boolean;
  isHeaderTextCapitalize?: boolean;
  primaryButton?: ModalButton;
  primaryButtonFirst?: boolean;
  secondaryButton?: ModalButton;
  modalContext: ModalContext;
  modalSize?: ModalSize;
  customButton?: TemplateResult;
  reversedFooter?: boolean;
  showClosingCross?: boolean;
  disableHeader?: boolean;
  disableFooter?: boolean;
  a11y?: ModalA11y;
  isModalCentered?: boolean;
  enableBackgroundBlur?: boolean;
  modalContentId?: string;
}

export declare interface ModalContext {
  component?: any;
  componentRef: string;
  componentRefData?: any;
}

export declare interface ModalA11y {
  announceBody?: boolean;
}

export enum ModalSize {
  DEFAULT = '',
  SMALL = 'modal-sm',
  LARGE = 'modal-lg',
  EXTRA_LAGE = 'modal-xl'
}
